export * from './GenericUtils'

// Named export for a single object with all utils
export * as GenericUtils from './GenericUtils'
